import { ReactNode } from 'react';
import { StatusState } from '../status/Status.types';

export enum AvatarType {
  icon = 'icon',
  initials = 'initials',
}

export enum AvatarVariant {
  primary = 'primary',
  secondary = 'secondary',
  colorFromName = 'colorFromName',
  /**
   * The teal account badge used across the headers. Its background is derived from the base
   * hue at render time so the initials stay legible — see AVATAR_ACCENT.
   */
  accent = 'accent',
}

export enum AvatarSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
}

export interface AvatarProps {
  type?: AvatarType;
  variant?: AvatarVariant;
  size?: AvatarSize;
  isOutline?: boolean;
  icon?: ReactNode;
  name?: string; // Full name - initials will be extracted (e.g., "John Payne" → "JP")
  initials?: string; // Explicit initials - takes priority over name extraction
  showStatus?: boolean;
  statusState?: StatusState;
  className?: string;
}
